import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from 'classnames';
import { VerticalStepperProvider } from './VerticalStepper.Context/VerticalStepper.Context.es.js';
import { VerticalStepperStep } from './VerticalStepper.Step/VerticalStepper.Step.es.js';

const VerticalStepper = ({ className, children, ...rest })=>{
    const childrenArray = Array.isArray(children) ? children : [
        children
    ];
    return jsx(VerticalStepperProvider, {
        ...rest,
        children: jsx("ol", {
            className: classNames('cb-vertical-stepper', className),
            "data-testid": "vertical-stepper",
            children: childrenArray.filter((step)=>!step.props.isHidden).map((step, index)=>{
                return /*#__PURE__*/ React__default.cloneElement(step, {
                    ...step.props,
                    key: index,
                    stepIndex: index
                });
            })
        })
    });
};
VerticalStepper.Step = VerticalStepperStep;

export { VerticalStepper, VerticalStepper as default };
//# sourceMappingURL=VerticalStepper.es.js.map
